import { BaseService } from "../base.service";
import { ErrorWrapper, ResponseWrapper } from "../util";

export class CompetitorsService extends BaseService {
    static get entity() {
        return "competitors"
    }

    static apiClient(options) {
        const baseURL = process.env.VUE_APP_API_URL;
        return this.initApiClient({ baseURL, ...options });
    }

    static async getLocations(params = {}) {
        try {
            const response = await this.apiClient().get('competitors/locations', { params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            const message = error.response.data ? error.response.data.error : error.response.statusText;
            throw new ErrorWrapper(error, message);
        }
    }

    static async getCompetitors(params = {}) {
        try {
            const response = await this.apiClient().get('competitors/get', { params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            const message = error.response.data ? error.response.data.error : error.response.statusText;
            throw new ErrorWrapper(error, message);
        }
    }

    static async getResults(params = {}) {
        try {
            const response = await this.apiClient().get('competitors/getresults', { params });
            return new ResponseWrapper(response, response.data);
        } catch (error) {
            const message = error.response.data ? error.response.data.error : error.response.statusText;
            throw new ErrorWrapper(error, message);
        }
    }
    
    // static async competitorsMissing(params = {}) {
    //     try {
    //         const response = await this.apiClient().get('competitors/competitors/missing', { params });
    //         return new ResponseWrapper(response, response.data);
    //     } catch (error) {
    //         const message = error.response.data ? error.response.data.error : error.response.statusText;
    //         throw new ErrorWrapper(error, message);
    //     }
    // }

}